<template>
  <b-card class="shadow" style="min-height: 700px" ref="printMe">
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h1 class="h3 mb-0 text-gray-800">
            {{ $t("Gráficos") }}
          </h1>

          <b-button-group>
            <b-button
              variant="outline-dark"
              :class="viewFilterReport === true ? 'active' : ''"
              @click="viewFilters"
            >
              <i class="fas fa-filter"></i>
              {{ $t("Filtros") }}
            </b-button>
            <b-button
              variant="outline-dark"
              :class="range === 'weekly' ? 'active' : ''"
              @click="updateAnalytics('weekly')"
            >
              <i class="fas fa-calendar-week"></i>
              {{ $t("Weekly") }}
            </b-button>
            <b-button
              variant="outline-dark"
              :class="range === 'monthly' ? 'active' : ''"
              @click="updateAnalytics('monthly')"
            >
              <i class="fas fa-calendar-alt"></i>
              {{ $t("Monthly") }}
            </b-button>
            <b-button
              variant="outline-dark"
              :class="range === 'yearly' ? 'active' : ''"
              @click="updateAnalytics('yearly')"
            >
              <i class="fas fa-calendar"></i>
              {{ $t("Yearly") }}
            </b-button>
          </b-button-group>
        </div>
      </div>
      <filter-reports
        :report="report"
        @loadlist="getAnalytics"
        :showFilterReport="viewFilterReport"
        @hideFilter="viewFilters"
        :data_inicio="data_inicio"
        :data_fim="data_fim"
        @update:data_inicio="data_inicio = $event"
        @update:data_fim="data_fim = $event"
      ></filter-reports>
      <div class="col-md-12">
        <b-tabs content-class="mt-3">
          <b-tab
            title="Renda Per Capita Familiar"
            active
            @click.prevent="changeTab('Renda Per Capita Familiar')"
          >
            <div
              class="col-md-12"
              style="min-height: 700px"
              v-if="tabAtiva == 'Renda Per Capita Familiar'"
            >
              <donut-graph
                titulo="Renda Per Capita Familiar"
                :loading="loading"
                :data="report.percapita"
                :range="range"
              />
            </div>
            <div class="col-md-12">
              <p class="text-muted small pb-1 mb-1">
                Total de
                <b v-if="report.totalFamiliasPercapita"
                  >({{ report.totalFamiliasPercapita }})
                </b>
                Famílias com dados de renda do cadastrado único ou inseridos por
                algum técnico usadas no gráfico
              </p>
              <p class="text-muted small">
                Foram ignoradas as famílias em que o seus usuários não tenham o
                campo de renda preenchido.
              </p>
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <div class="col-md-12 text-center">
        <b-button
          :title="$t('Imprimir')"
          class="py-2"
          size="sm"
          type="button"
          v-b-tooltip.hover
          variant="primary"
          @click="printHtml()"
        >
          <i class="fas fa-print"></i>
        </b-button>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "HomeReportFamilias",
  data() {
    return {
      loading: true,
      range: "yearly",
      report: {
        percapita: [],
        datas: {
          start: "",
          end: "",
        },
      },
      filtros: {},
      tabAtiva: "Renda Per Capita Familiar",
      data_inicio: "",
      data_fim: "",
    };
  },
  mounted() {
    this.getAnalytics();
  },
  methods: {
    changeTab(value) {
      if (value) {
        this.tabAtiva = value;
      } else {
        this.tabAtiva = "Renda Per Capita Familiar";
      }
      this.getAnalytics();
    },
    updateAnalytics(range) {
      if (this.range !== range) {
        this.range = range;
        this.getAnalytics();
      }
    },
    getAnalytics() {
      if (this.data_inicio) {
        this.filtros.data_inicial = this.$options.filters.formatDateYMD(
          this.data_inicio
        );
      }
      if (this.data_fim) {
        this.filtros.data_final = this.$options.filters.formatDateYMD(
          this.data_fim
        );
      }

      this.loading = true;
      const tab = { tab: this.tabAtiva };
      axios
        .get("api/dashboard/report/familias/graficos", {
          params: {
            range: this.range,
            filtros: this.filtros,
            ...tab,
          },
        })
        .then((response) => {
          this.loading = false;
          this.report = response.data.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    limparFiltros() {
      this.filtros = {};
      this.data_inicio = "";
      this.data_fim = "";
      this.getAnalytics();
    },
  },
};
</script>

